import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserServiceIdentity } from '../../../modules/IDENTITY_WEB/services/user.service';
import { ResetPasswordAdminViewModel } from '../../../modules/IDENTITY_WEB/models/user.model';
import { NotificationsService } from 'angular2-notifications';
import { CryptoService } from '../../../services/crypto.service';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.scss']
})
export class ResetPasswordDialogComponent implements OnInit {

  password: string = '';
  confirmPassword: string = '';
  hidePassword = true;
  hideConfirm = true;
  userName: string;
  email: string;
  saving: boolean;

  constructor(
    private _dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private userAdminService: UserServiceIdentity,
    public _notification: NotificationsService,
    private crypto: CryptoService
  ) { }

  ngOnInit(): void {
    this.userName = this.crypto.decrypt(this._data.UserName);
    this.email = this.crypto.decrypt(this._data.Email);
  }

  get passwordMismatch(): boolean {
    return (
      this.password &&
      this.confirmPassword &&
      this.password !== this.confirmPassword
    );
  }

  onCloseClick(): void {
    this._dialogRef.close(false);
  }

  canSave(): boolean {
    return (
      this.password?.length > 0 &&
      this.confirmPassword?.length > 0 &&
      !this.passwordMismatch
    );
  }
  onSave() {
    if (this.password.trim() == '' && this.confirmPassword.trim() == '')
      return;
    if (this.password.trim() !== '' && this.confirmPassword.trim() !== '' && this.password !== this.confirmPassword) {
      this._notification.error("Password and Confirm Password do not match");
      return;
    }
    this.saving = true;
    const payload: ResetPasswordAdminViewModel = {
      Email: this.crypto.encrypt(this.email),
      Password: this.crypto.encrypt(this.password),
      UserId: this.crypto.encrypt(this.userName)
    };

    this.userAdminService.resetPassword(payload).subscribe({
      next: (res) => {

        switch (res.Status) {
          case 1:
            this._notification.success(res.Message);
            this._dialogRef.close(true);
            this.saving = false;
            break;

          case 2:
            this._notification.warn(res.Message);
            this.saving = false;
            break;

          default:
            this._notification.error(res.Message);
            this.saving = false;
            break;
        }
      },
      error: () => {
        this._notification.error('Something went wrong while resetting password');
        this.saving = false;
      }
    });
  }
}
